<template>

</template>

<script>



export default {
  name: 'Footers',
  data(){
     return {
      }
  },

  mounted: function () {

    },
  methods: {
      }
    ,
  created(){

  },
  components:{
  }
}
</script>

<style>


</style>



// WEBPACK FOOTER //
// src/components/Footers.vue